// eslint-disable-next-line import/order
import type { ComponentType } from 'react';
// eslint-disable-next-line import/order
import Loadable from 'react-loadable';
import type { InvitePeopleDialogProps } from './main';

const LazyAddPeopleDialog: ComponentType<InvitePeopleDialogProps> & Loadable.LoadableComponent =
	Loadable({
		loader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_invite-people-dialog" */ './main'
			),
		loading: () => null,
	});
LazyAddPeopleDialog.displayName = 'lazy(AddPeopleDialog)';

export default LazyAddPeopleDialog;
